export default __webpack_public_path__ + "static/mdd-frame-04af2f43dde20ed2bfa87d1fd3b8d487.png";